import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import QuickViewModal from './QuickViewModal';

const Layout = ({ children }) => {
  useEffect(() => {
    // Fade out the Ultras preloader once React has mounted
    const el = document.getElementById('preloader-active');
    if (el) {
      setTimeout(() => {
        el.style.transition = 'opacity 0.5s';
        el.style.opacity = '0';
        setTimeout(() => { el.style.display = 'none'; }, 500);
      }, 300);
    }
  }, []);

  return (
    <>
      <Header />
      {children}
      <Footer />
      <QuickViewModal />
    </>
  );
};

export default Layout;
